import React from 'react'
import { Link } from 'react-router-dom'


function Logo({ isShow, className = 'text-dk-blue' }) {
    return (
        <div className={`relative w-[150px] ${isShow && "hidden"}`}>
            <Link to={'/'} className="text-1.5xl tracking-wider ">
                <span className={`absolute left-28 top-2.5 text-[.6rem] ${className}`}>TEACHER</span>
                <h1 className={`font-logo w-full text-[2.5rem] ${className} whitespace-nowrap`}>Lane Antunes</h1>
            </Link>
        </div>
    )
}

export default Logo
